import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { BfxMultiSelectorService } from "../bfx-element-library/bfx-multi-selector.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxBlotterFilterSelectorService extends BfxMultiSelectorService {
  constructor() {
    super();
  }
}
